import {createSlice} from "@reduxjs/toolkit";
import { SCREENSHARE_INFO } from "../../../constants/reducer_names";



const initialState = {
    isSuccess : false,
    sharingStatus:false,
    conId:''
};


const screenShareReducerSlice = createSlice({

    name:SCREENSHARE_INFO,
    initialState,
    reducers : {
        screenShareStatus : (state, {payload}) =>{
            state.isSuccess =payload.isSuccess;
            state.sharingStatus = payload.sharingStatus;
            state.conId = payload.conId
        }
    },
});


export const screenShareReducerAction = screenShareReducerSlice.actions;
export default screenShareReducerSlice.reducer;